<template>
  <ChessPuzzle />
</template>

<script>
import ChessPuzzle from "./components/ChessPuzzle.vue";

export default {
  name: "App",
  components: {
    ChessPuzzle,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
